import { lazy } from 'react';

const BankCheckSeries = lazy(() =>
  import('../pages/BankCheckSeries/components/index.js').then((module) => ({
    default: module.BankCheckSeries,
  })),
);

const bankCheckSeriesRoute = {
  public: [],
  auth: [
    {
      name: 'bank_check_series_maintenance',
      path: '/bank-check-series-maintenance',
      component: BankCheckSeries,
    },
  ],
};

export default bankCheckSeriesRoute;
